import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {styled} from '@mui/styles';
import moment from 'moment';
import React, {useCallback} from 'react';

const Nav = styled('div')(({theme}) => {
  const border = `1px solid ${theme.palette.grey['300']}`;
  const buttonSize = '60px';

  return {
    borderBottom: border,
    display: 'flex',

    '& h2': {
      alignItems: 'center',
      borderLeft: border,
      borderRight: border,
      display: 'flex',
      flex: 1,
      fontSize: '1.4em',
      fontWeight: 700,
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      textAlign: 'center',
    },

    '& button': {
      alignItems: 'center',
      background: 'none',
      border: 0,
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      display: 'flex',
      height: buttonSize,
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      width: buttonSize,

      '&:focus': {
        outline: 0,
      }
    }
  };
});

const WeekSelector = ({week, onSelectWeek}) => (
  <Nav>
    <button onClick={useCallback(() => {
      onSelectWeek(moment(week).clone().subtract(1, 'week'));
    }, [week, onSelectWeek])}><ChevronLeftIcon/></button>
    <h2>
      <span>{week.format('dddd Do MMMM YYYY')} - {week.clone().endOf('isoWeek').format('dddd Do MMMM YYYY')}</span>
    </h2>
    <button onClick={useCallback(() => {
      onSelectWeek(moment(week).clone().add(1, 'week'));
    }, [week, onSelectWeek])}><ChevronRightIcon/></button>
  </Nav>
);

export default WeekSelector;
